import React, { useMemo }  from 'react'
import DropDown from '../dropdown';
import { GetPaymentArrangements } from '../../../api/services/finance';

const PaymentArrangementsDropDown = ({...props}) => {
    return <DropDown search={false} api={GetPaymentArrangements} spec={useMemo(()=>{})} textField="Name" valueField="Id"  {...props}/>
}

export default PaymentArrangementsDropDown